import { Component, OnInit } from "@angular/core";

import { GlobalsService } from "../../globals.service";

import * as moment from "moment";

import { buildSettings } from "../../settings";

import { HeaderComponent } from "../../header/header.component";
import { settings } from "cluster";

//For jQuery
declare var $: any;
var generator = require("shortid");
var csv = require("csvtojson");

@Component({
  selector: "app-admin",
  templateUrl: "./admin.component.html",
  styleUrls: ["./admin.component.css"],
})
export class AdminComponent implements OnInit {
  private entityLogoBase64: string = null;
  private globals: GlobalsService;
  private addlicences: boolean = false;
  private deviceData = undefined;
  private debugMode: boolean = false;
  private showLicencing: boolean = buildSettings.addLicencing;
  private showAddLogo: boolean = buildSettings.addLogoOnNewAccount;
  private showImport: boolean = false;
  private key: string = "";

  constructor(globals: GlobalsService) {
    this.globals = globals;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    let fileSelector = document.getElementById("import-file");

    fileSelector.addEventListener("change", (event: any) => {
      //Get the file
      let file = event.target.files[0];

      //File valid?
      if (file) {
        //Get a reader
        let reader = new FileReader();

        reader.onload = (e: any) => {
          let content = e.target.result;

          csv({
            noheader: false,
            headers: ["imei", "snr", "iccid", "imsi"],
            output: "json",
          })
            .fromString(content)
            .then((data) => {
              this.onDeviceImport(data);
            });
        };

        reader.readAsText(file);
      }
    });
  }

  onDeviceImport(data: any) {
    this.deviceData = data;
  }

  onOpenLogo(event: any) {
    //Locals
    var input = event.target;
    var reader: any = new FileReader();

    reader.onload = () => {
      //Get only the data part
      var data = reader.result.split(",");

      //Data is valid?
      if (data.length == 2) {
        //Get the base64
        var base64 = data[1];

        //Get the image information
        var im = new Image();
        im.onload = () => {
          //Validate the size
          if (im.width == im.height && im.width == 512) {
            $("#logo").attr("src", reader.result);

            //Disable the "update button"
            $("#update-account-button").prop("disabled", false);

            //Success
            this.entityLogoBase64 = base64;
          } else {
            //Error
            this.globals.showWarningAlert(
              "Change Logo",
              "Only a square image with dimensions equal to 512 X 512 pixels is acceptable."
            );
          }
        };

        //Set the image source
        im.src = reader.result;
      }
    };

    //Read the data from the file
    reader.readAsDataURL(input.files[0]);
  }

  addUser() {
    let username: string = $("#add-user-username").val();
    let name: string = $("#add-user-name").val();
    let email: string = $("#add-user-email").val();
    let role: string = $("#add-user-role").val();

    //Check values exist
    if (
      username &&
      username != "" &&
      name &&
      name != "" &&
      email &&
      email != "" &&
      role &&
      role != ""
    ) {
      //Create Password
      let password: string = generator.generate();

      this.globals.peopleAdd(
        name,
        email,
        role,
        username,
        password,
        undefined,
        () => {
          //Success
          console.log("success");
          this.globals.showSuccessAlert(
            "Password",
            "The password for <b>" +
              username +
              "</b> is: <b>" +
              password +
              "</b>"
          );

          //Notify user
          let recipients = [email];
          let data = {
            "Username: ": email,
            "Password: ": password,
          };

          // this.globals.accountNotify(recipients,
          //     "New user created", "New user!",
          //     `A new user has been created for you on the ${this.globals.buildSettings.appName} platform. Please ignore this email if this was not meant for you. If this was meant for you use the following information to log into <a> ${this.globals.buildSettings.homeUrl} </a>.<br> Note: the password is only temporary and you should change it as soon as possible.`,
          //     data);

          this.globals.accountNewUserNotify(
            recipients,
            "New user created",
            email,
            password,
            name
          );
        },
        () => {
          //Error
          // this.globals.showWarningAlert("Error", "User could not be added.");
        }
      );
    } else {
      this.globals.showWarningAlert(
        "Error",
        "Please fill in all the fields before trying to add a new user."
      );
    }
  }

  closeAdmin() {
    HeaderComponent.instance.adminPage();
  }

  addAccount() {
    let me = this;
    //Get all the field values
    let name = $("#name-text").val();
    let companyName = $("#companyname-text").val();
    let phone = $("#phone-text").val();

    let email = $("#email-text").val();

    // let address = $("#address-text").val();
    // let web = $("#web-text").val();
    let addlic = this.addlicences;
    let licNum = $("#licence-numberof").val();
    let licValid = $("#licence-valid").val();

    //format licNum
    licNum = licNum == "" ? undefined : licNum;
    licValid = licValid == "" ? undefined : licValid;

    //check all fields formatted correctly
    let fieldsFormatted =
      name &&
      companyName &&
      phone &&
      email &&
      name.length > 0 &&
      companyName.length > 0 &&
      phone.length > 0 &&
      email.length > 0
        ? true
        : false;

    if (this.globals.validateEmail(email)) {
      //Get licence field formatted
      let licFormatted = true;
      if (addlic) {
        licFormatted =
          licNum && licValid && licNum.length > 0 && licValid.length > 0
            ? true
            : false;
      }

      //Disable the "update button"
      $("#update-account-button").prop("disabled", true);

      //Check all fields exists and valid
      if (licFormatted && fieldsFormatted) {
        //Data validation

        //Validate account valid
        this.globals.accountExists(email, (acc) => {
          if (acc.exists == true) {
            //Account exists
            this.globals.showWarningAlert(
              "Error",
              "An account is already registered to the email address provided."
            );
            $("#update-account-button").prop("disabled", false);
          } else {
            //Validate user valid
            this.globals.peopleExists(email, (person) => {
              if (person.exists == true) {
                //Person exists
                this.globals.showWarningAlert(
                  "Error",
                  "A user with the defined email already exists."
                );
                $("#update-account-button").prop("disabled", false);
              } else {
                //Verify devices
                let snrs = [];
                if (this.deviceData && this.deviceData.length > 0) {
                  for (let i = 0; i < this.deviceData.length; i++) {
                    let device = this.deviceData[i];

                    if (device && device.snr) {
                      //check if devices exists
                      //Only add if not already added
                      if (!snrs.includes(device.snr)) {
                        snrs.push(device.snr);
                      }
                    }
                  }
                }

                this.globals.deviceVerify(
                  snrs,
                  (devs: any) => {
                    if (devs && devs.success) {
                      //Create account
                      this.globals.accountConfigureNew(
                        companyName,
                        name,
                        undefined,
                        phone,
                        undefined,
                        email,
                        undefined,
                        this.entityLogoBase64,
                        licNum,
                        licValid,
                        "Devices",
                        this.deviceData,
                        (res: any) => {
                          //Success
                          // console.log(1)

                          email = email.toLowerCase();

                          let details = "";

                          if (res.accid) {
                            let entry = `<tr>
                        <td>Account ID:</td>
                        <td>${res.accid}</td>
                    </tr>`;

                            details = details.concat(entry);
                          }

                          if (res.username) {
                            let entry1 = `<tr>
                        <td>Username:</td>
                        <td>${res.username}</td>
                    </tr>`;

                            details = details.concat(entry1);
                          }

                          if (res.password) {
                            let entry2 = `<tr>
                        <td>Password:</td>
                        <td>${res.password}</td>
                    </tr>`;

                            details = details.concat(entry2);
                          }

                          if (res.licenceKey) {
                            let entry3 = `<tr>
                        <td>Licence Key:</td>
                        <td>${res.licenceKey}</td>
                    </tr>`;

                            details = details.concat(entry3);
                          }

                          if (res.validDate) {
                            let entry4 = `<tr>
                        <td>Licence valid until:</td>
                        <td>${res.validDate}</td>
                    </tr>`;

                            details = details.concat(entry4);
                          }

                          me.globals.showSuccessAlert(
                            "Success",
                            `
                <table style="text-align:left">
                    <thead>
                        <tr>
                            <th colspan="2">Account and user successfully created.</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${details}
                    </tbody>
                </table>`
                          );

                          //Send email
                          let recipients = [email];

                          let data = {
                            // "Account id: ": res.accid,
                            "Username: ": res.username,
                            "Password: ": res.password,
                            "Licence Key:": res.licenceKey,
                            "Licence Expiry:": res.validDate,
                          };

                          let licKey = res.licenceKey;
                          let validDate = res.validDate;

                          this.globals.accountNewAccountNotify(
                            recipients,
                            "New user created",
                            email,
                            res.password,
                            name,
                            licKey,
                            validDate
                          );

                          //Clear all fields
                          $("#name-text").val("");
                          $("#companyname-text").val("");
                          $("#phone-text").val("");
                          $("#address-text").val("");
                          $("#email-text").val("");
                          $("#web-text").val("");
                          this.entityLogoBase64 = undefined;
                          $("#checkbox-licences").val(false);
                          $("#licence-numberof").val("");
                          $("#licence-valid").val("");
                          $("#import-file").val("");
                          this.showImport = false;

                          $("#update-account-button").prop("disabled", false);
                        },
                        () => {
                          //Failure
                          this.globals.showWarningAlert(
                            "Error",
                            "The account could not be created."
                          );
                          $("#update-account-button").prop("disabled", false);
                        }
                      );
                    } else {
                      //Failure
                      //First snr
                      let snr = devs.snrs[0];
                      $("#update-account-button").prop("disabled", false);
                      this.globals.showWarningAlert(
                        "Error",
                        "Device already registered.<br> Serial Number: " + snr
                      );
                    }
                  },
                  () => {
                    //Failure
                    $("#update-account-button").prop("disabled", false);
                    this.globals.showWarningAlert(
                      "Error",
                      "Request could not be completed."
                    );
                  }
                );
              }
            });
          }
        });
      } else {
        //Not all fields are formatted correctly
        $("#update-account-button").prop("disabled", false);
        this.globals.showWarningAlert(
          "Error",
          "Some fields are empty or invalid."
        );
      }
    } else {
      this.globals.showWarningAlert("Error", "Email format is not correct.");
    }
  }

  importDevices() {
    $("#import-devices").modal("show");
  }

  addLicence() {
    //Get data
    let numberOfDevices = $("#add-licence-numberof").val();
    let validDate = $("#add-licence-valid").val();

    //Data validation
    if (
      numberOfDevices &&
      validDate &&
      validDate != "" &&
      numberOfDevices != ""
    ) {
      let licNum = parseInt(numberOfDevices);

      this.globals.licenceAdd(
        licNum,
        validDate,
        "safest",
        (r: any) => {
          this.key = r.key;
          let dt = moment(r.expirydate).format(this.globals.dateFormat);

          //Success
          this.globals.showSuccessOption(
            "Success",
            `Licence successfully added.<br><br>
        <table style="margin:auto" >
          <thead>
            
          </thead>
          <tbody>
            <tr>
              <td class="text-left pr-4">Key: </td>
              <td class="text-left"><b>${r.key}</b></td>
            </tr>
            <tr>
              <td class="text-left pr-4">Valid till: </td>
              <td class="text-left">${dt}</td>
            </tr>
          </tbody>
        </table>
        
        `,
            "OK",
            "Copy Key",
            () => {},
            () => {
              //Copy text
              //Get the element
              var dummyContent = "this is to be copied to clipboard";
              var dummy = $("<input>").val(this.key).appendTo("body").select();
              document.execCommand("copy");
            }
          );
        },
        () => {
          //Error
        }
      );
    } else {
      this.globals.showWarningAlert(
        "Invalid Fields",
        "Please fill in all the available fields."
      );
    }
  }
}
